import { debounce as lodashDebounce, throttle as lodashThrottle } from 'lodash';

export const throttle = lodashThrottle;

export const debounce = lodashDebounce;
